"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const choiceOptionsButtonTheme = {
    customBlue: {
        base: {
            backgroundColor: design_system_1.Colors.transparent,
            color: design_system_1.Colors.blue500,
        },
        disabled: {
            backgroundColor: design_system_1.Colors.transparent,
            color: design_system_1.Colors.grey500,
        },
        hover: {
            backgroundColor: design_system_1.Colors.blue100,
            color: design_system_1.Colors.blue500,
        },
        focus: {
            backgroundColor: design_system_1.Colors.blue100,
            outlineColor: design_system_1.Colors.blue500,
            color: design_system_1.Colors.blue500,
        },
    },
    customBlack: {
        base: {
            backgroundColor: design_system_1.Colors.transparent,
            color: design_system_1.Colors.black,
        },
        disabled: {
            backgroundColor: design_system_1.Colors.transparent,
            color: design_system_1.Colors.grey500,
        },
        hover: {
            backgroundColor: design_system_1.Colors.grey100,
            color: design_system_1.Colors.black,
        },
        focus: {
            backgroundColor: design_system_1.Colors.grey100,
            outlineColor: design_system_1.Colors.black,
            color: design_system_1.Colors.black,
        },
    },
};
const CustomMapperButton = ({ iconBefore, children, onClick, color, }) => (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupButtonContainer, tabIndex: -1 },
    common_utils_1.isolateComponent(design_system_1.Button, { color: color, colorTheme: choiceOptionsButtonTheme, iconBefore: iconBefore, onClick: onClick, size: "xsmall" }, children)));
exports.default = CustomMapperButton;
